import { Box, BoxProps } from '@jfs/ui-new'
import { Text } from '@jfs/ui-new/src/comps/TextNew'
import { NavigationContainer, NavigationIndependentTree } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import { FC } from 'react'
import EMI from '../screens/EMI'
import Card from '../screens/EMI/Card'
import { SavedCard } from '../screens/EMI/SavedCard'
import { PaymentProcessing } from '../screens/PaymentProcesseing'
import { pages } from '../utils/constants'

const EMIStack: FC = (props: any) => {
  const Stack = createStackNavigator()
  const styles = {
    container: { flex: 1 } as BoxProps,
  }

  return (
    <Box {...styles.container}>
      <NavigationIndependentTree>
        <NavigationContainer
          ref={props.navigationRef}
          onReady={props.onReady}
          onStateChange={props.onStateChange}
          {...props}
          independent={true}
          fallback={<Text>Loading...</Text>}>
          <Stack.Navigator initialRouteName={pages.emi} {...props} screenOptions={{ headerShown: false }}>
            <Stack.Screen name={pages.emi} component={EMI} />
            <Stack.Screen name={pages.emicard} component={Card} />
            <Stack.Screen name={pages.paymentProcessing} component={PaymentProcessing} />
            <Stack.Screen name={pages.emiSavedCard} component={SavedCard} />
          </Stack.Navigator>
        </NavigationContainer>
      </NavigationIndependentTree>
    </Box>
  )
}

export default EMIStack
